import { SxProps } from '@mui/material';

export const cardStyles: SxProps = {
  bgcolor: '#fff',
  minHeight: '60vh',
  padding: 4,
  mt: 4,
  boxShadow: 'rgba(50, 50, 93, 0.25) 0px 0px 5px 0px',
};
